import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Button, Box, Typography } from '@mui/material';
import { useRoutes, useAwsGetter } from '@localstack/services';
import { DEFAULT_API_GATEWAY_ROUTES } from '@localstack/constants';
import { AgwApiAuthorizerDetails as Details, Breadcrumbs } from '@localstack/ui';

import { ApiGatewayProps } from './types';
import { ApiNavTabs } from './components';

export const AgwApiAuthorizerDetails = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_API_GATEWAY_ROUTES,
}: ApiGatewayProps): ReactElement => {
  const { goto } = useRoutes();
  const { apiId: ApiId, authorizerId: AuthorizerId } = useParams<'apiId' | 'authorizerId'>();

  const { data: api } = useAwsGetter('ApiGatewayV2', 'getApi', [{ ApiId }], { clientOverrides });

  const { data: authorizer } = useAwsGetter('ApiGatewayV2', 'getAuthorizer', [{ ApiId, AuthorizerId }], {
    clientOverrides,
  });

  return (
    <Layout
      documentTitle="Authorizer Details"
      tabs={<ApiNavTabs apiId={ApiId as string} routes={routes} />}
      title={
        <Box>
          <Typography variant="h4">Authorizer Details</Typography>
          <Breadcrumbs
            mappings={[
              ['API Gateway', () => goto(routes.RESOURCES_AGW2)],
              [api?.Name, () => goto(routes.RESOURCES_AGW2_API, { apiId: ApiId })],
              [authorizer?.Name, null],
            ]}
          />
        </Box>
      }
      actions={
        <Button
          variant="outlined"
          onClick={() =>
            goto(routes.RESOURCES_AGW2_API_AUTHORIZER_UPDATE, { apiId: ApiId, authorizerId: AuthorizerId })
          }
        >
          Edit Authorizer
        </Button>
      }
    >
      <Card>
        <CardContent>
          <Details authorizer={authorizer} />
        </CardContent>
      </Card>
    </Layout>
  );
};
